import React, { useEffect, useState, useContext } from 'react';
import { socket } from './SocketConnection';
import AuthContext from '../../store/auth-context';
import './ChatComponent.scss';
import { ChatIdContext } from '../../store/chat-id-context';

const ChatComponent = ({user_Type}) => {
  const {chatId, setChatId} = useContext(ChatIdContext)
  const authCtx = useContext(AuthContext);
  const user = authCtx.userData.firstname;
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  const receiveId = (chatId) => {
    if(user_Type === 'user'){
      localStorage.setItem('chat_Id', chatId)
    }
    setChatId(chatId)
  }

  useEffect(() => {
    socket.connect();
    socket.on('chat_created', receiveId)
    socket.on('message', receiveMessage); 

    return () => {
      socket.off('message', receiveMessage);
      socket.disconnect(); 
    };
  }, []);

  useEffect(() => {
    if(user_Type === 'user' && chatId === null){
      socket.emit('create_chat')
    }else{
      socket.emit('join_chat', chatId); 
    }
  
    return () => {
      
    }
  }, [chatId])
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const newMessage = {
      body: message,
      from: user,
      chatId: chatId, 
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    socket.emit('send_message', newMessage); 
    setMessage('');
  };

  const receiveMessage = (message) => {
      setMessages((state) => [...state, message]);
  };

  const convertLinks = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const specialPhrase = 'MetLink';

    if (text.includes(specialPhrase)) {
      const link = text.split(specialPhrase)[1]?.trim();
      if (link && link.match(urlRegex)) {
        return (
          <button
            onClick={() => window.open(link, '_blank')}
            className='metlink-button'
          >
            Connect Here
          </button>
        );
      }
    }

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="chat-online">
      <ul>
        {messages.map((message, i) => (
          <li key={i}>
            <div className={`message ${message.from === user ? 'from-user' : 'from-system'}`}>
              {convertLinks(message.body)}
            </div>
          </li>
        ))}
      </ul>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Write your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type="submit">Send</button>
      </form>
    </div>
  );
};

export default ChatComponent;
